// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__yh3rP","head":"ProcedureTableInfo_head__3HWlM"};